import api from './authService';

export const getScheduledMeetings = () => {
  return api.get('/scheduled-meetings');
};

export const getScheduledMeeting = (id) => {
  return api.get(`/scheduled-meetings/${id}`);
};

export const createScheduledMeeting = (data) => {
  return api.post('/scheduled-meetings', data);
};

export const updateScheduledMeeting = (id, data) => {
  return api.put(`/scheduled-meetings/${id}`, data);
};

export const cancelScheduledMeeting = (id) => {
  return api.post(`/scheduled-meetings/${id}/cancel`);
};

export const deleteScheduledMeeting = (id) => {
  return api.delete(`/scheduled-meetings/${id}`);
};
